import { useState, useEffect, useRef } from 'react'
import foodItemsApiService from '../services/foodItemsApi.js'

// Custom hook for managing food items and sections with API
export function useFoodItems(menuType = null) {
  const [foodData, setFoodData] = useState({})
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [refreshing, setRefreshing] = useState(false)
  const previousMenuTypeRef = useRef(menuType)

  // Load food items and sections from API
  const loadFoodItems = async (currentMenuType = null, isMenuTypeSwitch = false) => {
    try {
      if (isMenuTypeSwitch) {
        setRefreshing(true)
      } else {
        setLoading(true)
      }
      setError(null)
      const data = await foodItemsApiService.getFoodItems(currentMenuType)
      setFoodData(data)
    } catch (err) {
      setError(err.message)
      console.error('Failed to load food items:', err)
    } finally {
      if (isMenuTypeSwitch) {
        setRefreshing(false)
      } else {
        setLoading(false)
      }
    }
  }

  // Load food items on component mount and when menuType changes
  useEffect(() => {
    const isMenuTypeSwitch = previousMenuTypeRef.current !== menuType && previousMenuTypeRef.current !== null
    loadFoodItems(menuType, isMenuTypeSwitch)
    previousMenuTypeRef.current = menuType
  }, [menuType])

  return {
    foodData,
    loading,
    refreshing,
    error,
    refreshFoodItems: loadFoodItems
  }
}
